module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "10px 0"
    }
  }, [_c('h3', [_vm._v("Control Panel "), _c('p', [_c('small', [_vm._v("Current Developer: " + _vm._s(_vm.$store.state.user.user.username))])])]), _c('hr'), _c('h5', [_vm._v("cabinet layout in database "), _c('button', {
    on: {
      "click": _vm.initLocalSystem
    }
  }, [_vm._v("Refresh")])]), _c('div', {
    staticClass: "layout-region"
  }, [_c('h5', [_vm._v(_vm._s(_vm.systemName))]), _vm._l((_vm.systemsCopy), function(sys, sys_num) {
    return _c('div', {
      staticClass: "system-layout"
    }, [_c('span', [_vm._v(_vm._s(sys.relative_index) + " (SN:" + _vm._s(sys.serial) + ")")]), _vm._l((sys.net_set), function(net, net_num) {
      return _c('div', {
        staticClass: "net-layout"
      }, [_c('div', {
        staticClass: "net-pos",
        class: {
          'background-green': net.LED_color === 'green', 'bling': net.LED_status, 'status-badge': true
        }
      }, [_c('span', [_vm._v(_vm._s(net.position))])]), _c('div', {
        staticClass: "net-content"
      }, [_c('span', {
        attrs: {
          "id": "netID"
        }
      }, [_vm._v("Drawer " + _vm._s(net.row_id) + " (id:" + _vm._s(net.id) + ")")]), _c('button', {
        on: {
          "click": function($event) {
            return _vm.openAllDevices(net)
          }
        }
      }, [_vm._v("OpenAll")]), _c('button', {
        staticClass: "float-right",
        on: {
          "click": function($event) {
            return _vm.toggleNet(sys_num, net_num)
          }
        }
      }, [_vm._v("Expand / Close")]), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (net.toggled),
          expression: "net.toggled"
        }],
        staticClass: "device-wrap"
      }, _vm._l((net.device_set), function(device) {
        return _c('div', {
          staticClass: "device-layout",
          class: {
            'background-green': device.LED_color === 'green', 'bling': device.LED_status
          }
        }, [_c('p', [_vm._v(_vm._s(device.pos_row) + " - " + _vm._s(device.relative_col) + " (w=" + _vm._s(device.width) + ",r=" + _vm._s(device.pos_col) + ",id=" + _vm._s(device.id) + ")")]), _c('div', [_c('button', {
          staticClass: "btn btn-primary btn-sm",
          on: {
            "click": function($event) {
              return _vm.openDeviceById(device.id)
            }
          }
        }, [(device.pos_row === 0) ? _c('span', [_vm._v("OpenDrawer")]) : _c('span', [_vm._v("Open")])]), _c('button', {
          staticClass: "btn btn-danger btn-sm",
          on: {
            "click": function($event) {
              return _vm.delDevice(device.id)
            }
          }
        }, [_vm._v("Remove")])])])
      }), 0)])])
    })], 2)
  })], 2), _c('hr'), _c('h5', [_vm._v("Detected Layout "), _c('button', {
    on: {
      "click": _vm.getDetectedDevices
    }
  }, [_vm._v("Refresh")])]), (_vm.detectedDevices.length !== 0) ? _c('div', {
    staticClass: "layout-region"
  }, [_c('div', {
    staticClass: "net-layout"
  }, [_c('div', {
    staticClass: "device-wrap"
  }, _vm._l((_vm.detectedDevices), function(device) {
    return _c('div', {
      staticClass: "device-layout"
    }, [_c('p', {
      staticClass: "text-center"
    }, [_vm._v("System: " + _vm._s(device.net.system))]), _c('p', {
      staticClass: "text-center"
    }, [_vm._v("Net:" + _vm._s(device.net.row_id) + " ")]), _c('p', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(device.pos_row) + " - " + _vm._s(device.relative_col) + " - width: " + _vm._s(device.width))]), _c('div', [_c('button', {
      staticClass: "btn btn-info btn-sm",
      on: {
        "click": function($event) {
          return _vm.setupDetectedDevice(device.id)
        }
      }
    }, [_vm._v("Add")]), _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.removeDetectedDevice(device.id)
        }
      }
    }, [_vm._v("Remove")])])])
  }), 0)])]) : _c('p', [_c('small', [_vm._v("No newly detected device in database.")])]), _c('hr'), _c('h5', [_vm._v("Testing tool")]), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.openTargetDrawerAndDevices($event)
      }
    }
  }, [_c('span', [_vm._v("藥櫃編號 ")]), _c('input', {
    attrs: {
      "placeholder": "cabinet index",
      "name": "cabInd",
      "type": "number"
    }
  }), _c('span', [_vm._v("抽屜編號")]), _c('input', {
    attrs: {
      "placeholder": "drawer index",
      "name": "drawerInd",
      "type": "number"
    }
  }), _c('span', [_vm._v(" ")]), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("開啟整層抽屜及藥盒")]), _c('small', [_vm._v("  (可按enter進行測試)")]), _c('p', [_vm._v("last tested cabinet index: " + _vm._s(_vm.previousTestCabInd) + ", drawer index: " + _vm._s(_vm.previousTestDrawerInd))]), _c('p', [_vm._v("目前測試次數: " + _vm._s(_vm.testTimes))])]), _c('hr'), _c('h5', [_vm._v("Other command")]), _c('button', {
    on: {
      "click": _vm.sendLayoutCommand
    }
  }, [_vm._v("Rescan layout")]), _c('button', {
    on: {
      "click": _vm.removeAllDevices
    }
  }, [_vm._v("Remove All Devices")]), _c('button', {
    on: {
      "click": _vm.removeAllDrugStorages
    }
  }, [_vm._v("Remove All DrugStorages")]), _c('button', {
    on: {
      "click": _vm.createRandomDrugStorages
    }
  }, [_vm._v("Create Random DrugStorages")]), _c('button', {
    on: {
      "click": _vm.removeAllEvent
    }
  }, [_vm._v("Remove all Events")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03fe9bc7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dev/DevPanel.vue
// module id = 1369
// module chunks = 1